import { OrganismeTypeCode } from './enums/type-organisme.enum';
export class OrganismeType {
    static jsonMap = {
        id: 'id',
        code: { key: 'code', optional: true },
        libelle: { key: 'libelle', optional: true, default: '' }
    };

    public id: number;
    public code: OrganismeTypeCode;
    public libelle: string;
}
